import React, { useEffect } from "react"
import styled from "styled-components"
import media from "../styles/media"
import colors from "../styles/colors"
import getMedia from "../utils/getMedia"
import DownChevron from "../images/ChevronDown.svg"
import gsap from "gsap"
import ContentWidth from "./ContentWidth"
import text from "styles/text"

const Accordion = ({ content }) => {
  const margin = getMedia(
    "0 0 50px 0",
    "0 0 3.472vw 0",
    "0 0 4.883vw 0",
    "0 0 13.333vw 0"
  )

  useEffect(() => {
    const boxes = gsap.utils.toArray(".acc-box")

    boxes.forEach((accordion, index) => {
      const tl = gsap.timeline()
      accordion.animation = tl
        .to(`#acc-${index}`, { height: "auto", opacity: 1, margin })
        .reversed(true)
        .to(`#chevron-${index}`, { rotate: 180 }, "<0")
        .reversed(true)

      accordion.addEventListener("click", expand)
    })

    function expand() {
      this.animation.reversed(!this.animation.reversed())
    }
  }, [margin])

  const allAccordions = content.accordion.map((acc, index) => (
    <AccordionRowsContainer key={acc.headline}>
      <AccordionRow className="acc-box">
        <AccordionHeader>{acc.headline}</AccordionHeader>
        <AccordionChevron
          id={`chevron-${index}`}
          alt="down chevron"
          src={DownChevron}
        />
      </AccordionRow>
      <AccordionBody
        id={`acc-${index}`}
        dangerouslySetInnerHTML={{ __html: acc.bodyCopy }}
      />
    </AccordionRowsContainer>
  ))

  return (
    <ContentWidth>
      <AccordionContainer>
        <AccordionIntroHeader>{content.headline}</AccordionIntroHeader>
        <AccordionIntroBody
          dangerouslySetInnerHTML={{ __html: content.bodyCopy }}
        />
        <AccordionRows>{allAccordions}</AccordionRows>
      </AccordionContainer>
    </ContentWidth>
  )
}

const AccordionIntroHeader = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  ${text.h2}
  margin-bottom: 2.083vw;
  font-size: 2.778vw;
  width: 79.444vw;

  ${media.fullWidth} {
    margin-bottom: 30px;
    font-size: 40px;
    width: 1144px;
  }

  ${media.tablet} {
    margin-bottom: 2.93vw;
    font-size: 3.906vw;
    width: 92.188vw;
  }

  ${media.mobile} {
    font-size: 8.346vw;
    margin-bottom: 7.009vw;
    text-align: center;
    width: 90vw;
  }
`
const AccordionIntroBody = styled.p`
  text-align: center;
  width: 75vw;
  margin-bottom: 2.083vw;
  font-size: 1.389vw;

  ${media.fullWidth} {
    font-size: 20px;
    width: 1200px;
    margin-bottom: 30px;
  }

  ${media.tablet} {
    margin-bottom: 2.93vw;
    width: 75vw;
    font-size: 1.953vw;
  }

  ${media.mobile} {
    width: 95vw;
    margin-bottom: 7.009vw;
    font-size: 4.673vw;
  }
`
const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const AccordionRowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const AccordionBody = styled.div`
  ${text.bodyMd}
  display: flex;
  overflow: hidden;
  background-color: ${colors.whitePurple};
  width: 79.444vw;
  padding-right: 1.667vw;
  height: 0;
  opacity: 0;

  ${media.fullWidth} {
    width: 1144px;
    padding-right: 24px;
  }

  ${media.tablet} {
    width: 88.281vw;
    padding-right: 2.344vw;
  }

  ${media.mobile} {
    padding-right: 5.607vw;
    width: 87.85vw;
  }
`
const AccordionChevron = styled.img`
  width: 1.389vw;
  height: 1.389vw;
  margin-left: auto;

  ${media.fullWidth} {
    width: 20px;
    height: 20px;
  }

  ${media.tablet} {
    width: 1.953vw;
    height: 1.953vw;
  }

  ${media.mobile} {
    width: 3.673vw;
    height: 3.673vw;
  }
`
const AccordionHeader = styled.h2`
  ${text.bodyMdBold}
  color: ${colors.grey800};

  ${media.fullWidth} {
  }

  ${media.tablet} {
  }

  ${media.mobile} {
    max-width: 66.355vw;
  }
`
const AccordionRows = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`
const AccordionRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 79.444vw;
  border-top: 0.069vw solid ${colors.grey700};
  padding: 2vw 3.472vw 2vw 0vw;
  height: auto;

  ${media.hover} {
    :hover {
      cursor: pointer;
    }
  }

  ${media.fullWidth} {
    border-top: 1px solid ${colors.grey700};
    padding: 29px 50px 29px 0px;
    width: 1144px;
  }

  ${media.tablet} {
    border-top: 0.098vw solid ${colors.grey700};
    padding: 3vw 4.883vw 3vw 0vw;
    width: 88.281vw;
  }

  ${media.mobile} {
    border-top: 0.234vw solid ${colors.grey700};
    padding: 5vw 11.682vw 5vw 0vw;
    width: 87.85vw;
  }
`

export default Accordion
